import { ArrowButton, Button, DatePicker, TextField } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { codebookRouteEducationSector } from '../../routes/routes';
import styles from "./RequestCodeBook.module.scss";


export default function CodeBookEducationSectorEdit(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  const navigateToEducationSector = () => {
    history.push(
      codebookRouteEducationSector()
    );
  }
  return (
    <>
      <Row>
        <Col md={12}>
          <ArrowButton
            backwards
            ariaLabel=""
            onClick={navigateToEducationSector}
          />
          <span className={styles.backButtonCaption}>
            {t("codeBook.navigateToCodeBook")}
          </span>

        </Col>
      </Row>
      <Row className={styles.title}>
        <Col md={6}>
          <h3>{t("codeBook.educationSector")}</h3>
        </Col>
        <Col md={6} className="d-flex justify-content-end align-items-right">
          <Button
            outline
            className={styles.actionButton}>
            {t("common.cancel")}
          </Button>
          <Button className={styles.actionButton}>
            {t("common.save")}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md={4} className="mt-5">
          <TextField
            disabled
            label={t("common.name")}
            value={(location.state as any).educationSector?.name!}
          />
        </Col>
      </Row>
      <Row>
        <Col md={4} className="mt-5">
          <DatePicker
            label={t("common.dateTo")}
            minYear={new Date().getFullYear() - 25}
            maxYear={new Date().getFullYear() + 25}
          />
        </Col>
      </Row>
    </>
  );
}